var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.414 4.4385L22 5.8515L26.168 10.0005H16.5C15.0418 10.0021 13.6438 10.5821 12.6127 11.6132C11.5816 12.6443 11.0016 14.0423 11 15.5005C11 18.5335 13.468 21.0005 16.5 21.0005H17V19.0005H16.5C14.57 19.0005 13 17.4305 13 15.5005C13 13.5705 14.57 12.0005 16.5 12.0005H26.172L22.008 16.1645L23.422 17.5785L30 11.0005L23.414 4.4375V4.4385ZM5 5.0005V27.0005H27V17.0005L25 19.0005V25.0005H7V7.0005H17.854L19.854 5.0005H5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconWhite);
export default __webpack_public_path__ + "static/media/share_icon_white.97ae537ee8a261da6c77f353ff53d6b2.svg";
export { ForwardRef as ReactComponent };